module.exports = __webpack_public_path__ + "img/ld.f84b10db.png";